/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';

/**
 * The FireControllerInformation model module.
 * @module model/FireControllerInformation
 * @version 1.1.0
 */
class FireControllerInformation {
    /**
     * Constructs a new <code>FireControllerInformation</code>.
     * Information about a Fire Controller device but does not include the Fire Controller ID
     * @alias module:model/FireControllerInformation
     */
    constructor() { 
        
        FireControllerInformation.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FireControllerInformation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireControllerInformation} obj Optional instance to populate.
     * @return {module:model/FireControllerInformation} The populated <code>FireControllerInformation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireControllerInformation();

            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('latitude')) {
                obj['latitude'] = ApiClient.convertToType(data['latitude'], 'Number');
            }
            if (data.hasOwnProperty('longitude')) {
                obj['longitude'] = ApiClient.convertToType(data['longitude'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireControllerInformation</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireControllerInformation</code>.
     */
    static validateJSON(data) {
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }

        return true;
    }


}



/**
 * Address of the Device
 * @member {module:model/Address} address
 */
FireControllerInformation.prototype['address'] = undefined;

/**
 * Geographic latitude of the device. May be supplied directly by the caller (e.g., for remote locations with no postal address) or derived automatically via geocoding when an address is provided. Explicit caller-supplied values take precedence over geocoding. A null value means coordinates are not yet resolved — the device will be excluded from neighbor searches. 
 * @member {Number} latitude
 */
FireControllerInformation.prototype['latitude'] = undefined;

/**
 * Geographic longitude of the device. See latitude description for details. 
 * @member {Number} longitude
 */
FireControllerInformation.prototype['longitude'] = undefined;






export default FireControllerInformation;

